import React, { useState, useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../../utils/story";
import { HeroImage } from "../../../atoms/HeroImage";
import { Label } from "../../../atoms/Label";
import Headline from "../../../atoms/Headline";
import SubHeadline from "../../../atoms/SubHeadline";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import { Link } from "@quintype/components";
import { DfpComponent } from "../../../ads/dfp-component";
import { useDeviceType } from "../../../custom-hooks/useDeviceType";

import "./entity-articles.m.css";

export const EntityArticles = ({ name }) => {
  const StoryTextContent = ({ story, type, isSubHeadlineToShow = false, showLabel }) => {
    const { subheadline } = story;
    const headline = getStoryHeadline(story);
    return (
      <div styleName={`${type}-story-box`}>
        {getStoryLabel(story) && showLabel && <Label story={story} />}
        {headline && <Headline headline={headline} styleName={`${type}-headline`} />}
        {isSubHeadlineToShow && subheadline && (
          <SubHeadline subHeadline={subheadline} styleName={`${type}-subheadline`} />
        )}
        <PublishAndReadTime showReadTime={true} showTimestamp={true} story={story} />
      </div>
    );
  };

  const StoryComponent = ({ story, type, isImageToShow = false, isSubHeadlineToShow = false }) => {
    const externalStoryUrl = isExternalStory(story);
    const href = externalStoryUrl || `/${story?.slug}`;
    const target = externalStoryUrl ? "_blank" : "_self";
    return (
      <Link href={href} target={target}>
        {isImageToShow ? (
          <div styleName={`${type}-story-container`}>
            <StoryTextContent story={story} type={type} isSubHeadlineToShow={isSubHeadlineToShow} showLabel={true} />
            <div styleName={`${type}-story-image-container`}>
              <HeroImage
                story={story}
                widths={[135]}
                aspectRatio={[[4, 3]]}
                headline={getStoryHeadline(story)}
                iconSizes={{ width: 48, height: 48 }}
              />
            </div>
          </div>
        ) : (
          <StoryTextContent story={story} type={type} isSubHeadlineToShow={isSubHeadlineToShow} showLabel={true} />
        )}
      </Link>
    );
  };

  const sideAd1 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sidebar_right_1"], {}));
  const footerAd = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "footer_1"], {}));

  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const limit = 5;
  const [offset, setOffset] = useState(0);
  const [articles, setArticles] = useState([]);
  const [totalItem, setTotalItem] = useState(0);

  const getArticles = async () => {
    try {
      const storyFields =
        "headline,subheadline,slug,url,hero-image-s3-key,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,author-name,sections,read-time";

      const response = await fetch(
        `/api/v1/advanced-search?limit=${limit}&offset=${offset}&story-attributes.entity=${name}&fields=${storyFields}&sort=latest-published`
      );
      const items = await response.json();
      setTotalItem(items?.total);
      return items?.items;
    } catch (error) {
      console.error("Error", error);
    }
  };

  const loadMore = async () => {
    const newArticles = await getArticles();
    setArticles([...articles, ...newArticles]);
    setOffset((prevOffset) => prevOffset + limit);
  };
  useEffect(() => {
    loadMore();
  }, []);

  if (!totalItem) return null;
  return (
    <>
      <div styleName="entity-articles-wrapper">
        <div styleName="entity-articles-list">
          <div styleName="title">Read more</div>
          {articles.map((story, i) => (
            <Fragment key={i}>
              <StoryComponent story={story} type="secondary" isImageToShow={true} isSubHeadlineToShow={true} />
              {i < articles.length - 1 && <div styleName="horizontal-separator"></div>}
            </Fragment>
          ))}
          {totalItem > offset && <div styleName="load-more">{<button onClick={loadMore}>LOAD MORE</button>}</div>}
        </div>
        <div styleName="separartor"></div>
        {isDesktop && (
          <div styleName="right-column">
            <div styleName="right-top-ad-slot">
              <DfpComponent adStyleName="ad-slot-size-300x600" id={sideAd1?.id} />
            </div>
          </div>
        )}
      </div>
      <div styleName="bottom-ad-container">
        <DfpComponent adStyleName={"ad-slot-size-970x250"} id={footerAd?.id} />
      </div>
    </>
  );
};
